module.exports = __webpack_public_path__ + "website/img/dl2.a74ad784.jpg";